import { Component, OnInit } from '@angular/core';
import { ChangePasswordRequest } from '../models/account';
import * as sha256 from 'sha256';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

declare var $: any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  old_password: string;
  new_password: string;
  cnf_password: string;

  passNotMatch = false;
  passNotUppercase = false;
  passNotLowercase = false;
  passNotNumber = false;
  passNotSymbol = false;
  failMessage: string;
  isLoading: boolean;
  public patternCharacter = '(=!@#$%^&*()~\|<>{}[])';

  upperCase = /[A-Z]/;
  lowerCase = /[a-z]/;
  numbers = /[0-9]/;
  symbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  constructor(private router: Router,
    private authService: AuthenticationService) { }

  ngOnInit() {
    firebase.analytics().logEvent('profil_ubah_password_page');
  }

  passwordOnChange(){
    if(this.upperCase.test(this.new_password)) {
      this.passNotUppercase = false;
    }
    if(!this.upperCase.test(this.new_password)) {
      this.passNotUppercase = true;
    }
    if(this.lowerCase.test(this.new_password)) {
      this.passNotLowercase = false;
    }
    if(!this.lowerCase.test(this.new_password)) {
      this.passNotLowercase = true;
    }
    if(this.numbers.test(this.new_password)) {
      this.passNotNumber = false;
    }
    if(!this.numbers.test(this.new_password)) {
      this.passNotNumber = true;
    }
    if(this.symbol.test(this.new_password)) {
      this.passNotSymbol = false;
    }
    if(!this.symbol.test(this.new_password)) {
      this.passNotSymbol = true;
    }
  }

  confirmPasswordOnChange(){
    if(this.new_password == this.cnf_password){
      this.passNotMatch = false;
    }
    if(this.new_password != this.cnf_password){
      this.passNotMatch = true;
    }
  }

  save(isValid){
    this.failMessage = '';
    if(!this.upperCase.test(this.new_password)) {
      this.passNotUppercase = true;
      isValid = false;
    }
    if(!this.lowerCase.test(this.new_password)) {
      this.passNotLowercase = true;
      isValid = false;
    }
    if(!this.numbers.test(this.new_password)) {
      this.passNotNumber = true;
      isValid = false;
    }
    if(!this.symbol.test(this.new_password)) {
      this.passNotSymbol = true;
      isValid = false;
    }
    if(this.new_password != this.cnf_password){
      this.passNotMatch = true;
      return;
    }
    if(isValid){
      this.isLoading = true;
      this.passNotMatch = false;
      const data = new ChangePasswordRequest();
      data.current_password = sha256(this.old_password);
      data.new_password = sha256(this.new_password);
      this.authService.changePassword(data,
        resp =>{
          this.isLoading = false;
          if(resp.alert.code == 200){
            this.authService.logout();
            this.old_password = '';
            this.new_password = '';
            this.cnf_password = '';
            $('#success').modal('show');
            setTimeout(() => {
              $('#success').modal('hide');
              this.router.navigate(['/']);
            }, 2000);
          }else{
            this.failMessage = resp.alert.message;
            $('#fail').modal('show');
          }
        },
        err =>{
          this.isLoading = false;
          this.failMessage = err;
            $('#fail').modal('show');
        });
    }
  }

}
